"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlansHeader;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../elements/other/headline-lockup/index.js"));
var _index2 = _interopRequireDefault(require("../../elements/buttons/link/index.js"));
var _list = _interopRequireDefault(require("@site/pattern-library-core/list"));
var _merchButton = require("@site/pattern-library-core/merch-button");
const PlansHeaderContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PlansHeaderContainer",
  class: "pl-p4y37a7"
});
const PreCheckListLearnAboutContainer = /*#__PURE__*/(0, _react2.styled)('div')({
  name: "PreCheckListLearnAboutContainer",
  class: "pl-p17nmu6b"
});
const PreCheckList = /*#__PURE__*/(0, _react2.styled)(_list.default)({
  name: "PreCheckList",
  class: "pl-p5nqmlo"
});
const LearnAboutButton = /*#__PURE__*/(0, _react2.styled)('div')({
  name: "LearnAboutButton",
  class: "pl-l1a09jlp"
});
const ComparePlansButton = /*#__PURE__*/(0, _react2.styled)('div')({
  name: "ComparePlansButton",
  class: "pl-cgmks3y"
});
function PlansHeader(props) {
  const {
    heading,
    preCheckListItems,
    learnAboutCta,
    comparePlansCta
  } = props;
  const headlineProps = {
    heading: heading,
    headlineSize: 'h1',
    headlineLineLength: null,
    textAlign: 'start'
  };
  const preCheckProps = {
    iconType: 'checkmark',
    iconColor: 'black',
    items: preCheckListItems
  };
  if (learnAboutCta) {
    Object.assign(learnAboutCta, {
      design: 'arrow',
      templateName: 'Link'
    });
  }
  if (comparePlansCta) {
    Object.assign(comparePlansCta, {
      shrinkOn: 'mobile',
      design: 'secondary',
      templateName: 'Button Component',
      size: 'small'
    });
  }
  return /*#__PURE__*/_react.default.createElement(PlansHeaderContainer, {
    "data-cy": "plans-header"
  }, /*#__PURE__*/_react.default.createElement(_index.default, headlineProps), /*#__PURE__*/_react.default.createElement(PreCheckListLearnAboutContainer, null, /*#__PURE__*/_react.default.createElement(PreCheckList, (0, _extends2.default)({
    dataCy: "pre-check-list"
  }, preCheckProps)), learnAboutCta && /*#__PURE__*/_react.default.createElement(LearnAboutButton, {
    "data-cy": "learn-about-button"
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: [learnAboutCta],
    templateMap: {
      Link: _index2.default
    }
  }))), comparePlansCta && /*#__PURE__*/_react.default.createElement(ComparePlansButton, {
    "data-cy": "compare-plans-button"
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: [comparePlansCta],
    templateMap: {
      Link: _index2.default
    }
  })));
}
PlansHeader.propTypes = {
  heading: _propTypes.default.string,
  preCheckListItems: _propTypes.default.shape(_list.default.propTypes),
  learnAboutCta: _propTypes.default.object,
  comparePlansCta: _propTypes.default.object
};